export default "__VITE_ASSET__Dwapxr9f__"